/**
 * Password Reset API Client
 * Handles password reset flow for clients
 */

import { portalApiClient as apiClient } from './portal';

export interface RequestResetData {
  email: string;
}

export interface ValidateTokenData {
  token: string;
}

export interface ResetPasswordData {
  token: string;
  newPassword: string;
}

export const passwordResetApi = {
  /**
   * Request password reset email
   */
  requestReset: async (data: RequestResetData): Promise<{ message: string }> => {
    const response = await apiClient.post('/portal/password-reset/request', data);
    return response.data;
  },

  /**
   * Validate reset token
   */
  validateToken: async (data: ValidateTokenData): Promise<{ valid: boolean; email: string }> => {
    const response = await apiClient.post('/portal/password-reset/validate', data);
    return response.data;
  },

  /**
   * Reset password with token
   */
  resetPassword: async (data: ResetPasswordData): Promise<{ message: string }> => {
    const response = await apiClient.post('/portal/password-reset/reset', data);
    return response.data;
  },
};
